@if (viewModel$ | async; as vm) {
    <div class="quick-bet__summary">
        @if (vm.pickDetails?.isEachWay) {
            <bs-quick-bet-each-way-total-stake [totalStake]="vm.pickDetails.totalStake"></bs-quick-bet-each-way-total-stake>
        }
        @if (quickBetConfig.isTotalReturnsEnabled) {
            @if (!quickBetConfig.isPossibleWinningsUnderStakeInputEnabled) {
                <bs-quick-bet-total-returns [pickIds]="vm.pickIds"></bs-quick-bet-total-returns>
                @if (vm.pickDetails?.tokenContext) {
                    <bs-digital-token-summary-container *msShowInEpcot="{ showInEpcot: false }" [tokenContext]="vm.pickDetails.tokenContext">
                    </bs-digital-token-summary-container>
                }
            }
            <bs-quick-bet-taxation-liability></bs-quick-bet-taxation-liability>
        }
    </div>
}
